import React from "react";
import "./shared.css";

export default function EmptyState({
  title,
  description,
  icon: Icon,
  actionLabel,
  onAction,
}) {
  return (
    <div className="empty-state-shared">
      {Icon && (
        <div className="empty-state-icon-wrap">
          <Icon size={36} className="empty-state-icon" />
        </div>
      )}
      <h3 className="empty-state-title">{title}</h3>
      <p className="empty-state-desc">{description}</p>
      {actionLabel && onAction && (
        <button type="button" className="btn-shared btn-primary btn-size-md" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}
